import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

import Select from '../../../components/ui/Select';

const SearchFilterBar = ({ onSearch, onFilter, onAddCustomer }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    location: 'all',
    serviceType: 'all'
  });

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Pending', label: 'Pending' }
  ];

  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'New York, NY', label: 'New York, NY' },
    { value: 'Los Angeles, CA', label: 'Los Angeles, CA' },
    { value: 'Chicago, IL', label: 'Chicago, IL' },
    { value: 'Houston, TX', label: 'Houston, TX' },
    { value: 'Phoenix, AZ', label: 'Phoenix, AZ' }
  ];

  const serviceTypeOptions = [
    { value: 'all', label: 'All Service Types' },
    { value: 'HVAC', label: 'HVAC' },
    { value: 'Plumbing', label: 'Plumbing' },
    { value: 'Electrical', label: 'Electrical' },
    { value: 'Appliance', label: 'Appliance' }
  ];

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    onSearch(value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      status: 'all',
      location: 'all',
      serviceType: 'all'
    };
    setFilters(clearedFilters);
    setSearchQuery('');
    onFilter(clearedFilters);
    onSearch('');
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-1 p-4 md:p-6 space-y-4">
      <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3">
        <div className="flex-1">
          <div className="relative">
            <Icon
              name="Search"
              size={20}
              color="var(--color-muted-foreground)"
              className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
            />
            <input
              type="text"
              placeholder="Search by name, company, email, or phone..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full pl-10 pr-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
            />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            iconName="Filter"
            iconPosition="left"
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            className="flex-1 lg:flex-none"
          >
            Filters
          </Button>
          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            onClick={onAddCustomer}
            className="flex-1 lg:flex-none"
          >
            Add Customer
          </Button>
        </div>
      </div>
      {showAdvancedFilters && (
        <div className="pt-4 border-t border-border space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Select
              label="Status"
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => handleFilterChange('status', value)}
            />
            <Select
              label="Location"
              options={locationOptions}
              value={filters?.location}
              onChange={(value) => handleFilterChange('location', value)}
              searchable
            />
            <Select
              label="Service Type"
              options={serviceTypeOptions}
              value={filters?.serviceType}
              onChange={(value) => handleFilterChange('serviceType', value)}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="text-sm text-muted-foreground">
              {filters?.status !== 'all' || filters?.location !== 'all' || filters?.serviceType !== 'all' ?'Active filters applied' :'No filters applied'}
            </div>
            <Button variant="ghost" size="sm" onClick={handleClearFilters}>
              Clear All Filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchFilterBar;